import { IdwFormLabelWithIconContainer } from "@containers/common/idw-form-label-with-icon-container/idw-form-label-with-icon-container";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { DEFAULT_AXNUI_CONTENT } from "@iddataweb/idw-common-ui/constants";
import { AXNUIDateInput } from "@iddataweb/idw-common-ui/containers";
import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import commonStyles from "@styles/common.less";
import { useMemo } from "react";

type AXNUIThemingDateInputComponentProps = {
    id: string;
    locale: LocaleTypes;
    isRequired: boolean;
    label: string;
    placeholder?: string;
};

export const AXNUIThemingDateInputComponent = (props: AXNUIThemingDateInputComponentProps) => {
    const { id, isRequired, label, placeholder, locale } = props;
    const dateFormat = useMemo(() => DEFAULT_AXNUI_CONTENT[locale].form.date.dateFormat, [locale]);

    return (
        <div className={commonStyles.axnuiPreviewInputContainer}>
            {label && (
                <IdwFormLabelWithIconContainer
                    controlId={`attribute-input-label-${id}`}
                    label={label}
                    isRequired={isRequired}
                    layout={LayoutTypes.COLUMN}
                    labelWidth={LabelWidthTypes.MEDIUM}
                />)}

            <AXNUIDateInput
                controlId={id}
                required={isRequired}
                disabled={false}
                dropdownMode="select"
                ariaLabel={label}
                placeholder={placeholder || dateFormat.toUpperCase()}
                title={null}
                onChange={() => { }}
                onBlur={() => { }}
                typedDate={""}
                onRawChange={() => { }}
                shouldCloseOnSelect={true}
                isValidDate={false}
                showYearDropdown={true}
                showMonthDropdown={true}
                dateFormat={dateFormat}
                locale={locale} />
        </div>
    );
};